export enum DisplayType{
  PHONE = 'phone',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}
